import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { ReactElement } from "react";

interface VehicleValuationExpiryTooltipProps {
  isExpired: boolean;
  reason: string;
  children: ReactElement;
}

export function VehicleValuationExpiryTooltip({
  isExpired,
  reason,
  children,
}: VehicleValuationExpiryTooltipProps): ReactElement {
  if (!isExpired) {
    return children;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-not-allowed" tabIndex={0} aria-disabled="true">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent>{reason}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
